import { getSystemSetting } from "../Redux/Generic/GenericReducer";

export const GetProcessParam = (key: string) => {
  let systemSetting = getSystemSetting(key);
  if (systemSetting) {
    //console.log("Loaded parameter from settings", key, systemSetting);
    return systemSetting;
  } else {
    //Commentato per evitare troppo rumore in console log
    //console.log("Loaded parameter from defaults", key, process.env[key]);
    return process.env[key];
  }
};
